import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';

const pageContentCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;box-sizing:border-box;display:flex;flex-direction:column;font-family:Open Sans;font-size:.875rem;font-weight:400;height:100%;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal;width:100%}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}:host main{align-content:flex-start;align-items:stretch;background-color:var(--jw-theme-surface-body-bg-color);display:flex;flex:1;flex-direction:column;flex-wrap:wrap;gap:1rem;padding:1.5rem 1.5rem 4rem}:host([fixed-min-width=true]){min-width:var(--jw-container-xl)}";
const WuiPageContentStyle0 = pageContentCss;

const WuiPageContent$1 = /*@__PURE__*/ proxyCustomElement(class WuiPageContent extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.fixedMinWidth = false;
    }
    render() {
        return (h(Host, { key: 'd9fd3fce5f376f7e1648dd64b5354ff39fac83e1' }, h("main", { key: 'd4592a8bdbf4917414ec7c7a18fe77e96a4a4bbd' }, h("slot", { key: 'cd7479e263ac48e1b77ae87673cc082831a8af74' }))));
    }
    static get style() { return WuiPageContentStyle0; }
}, [1, "wui-page-content", {
        "fixedMinWidth": [516, "fixed-min-width"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-page-content"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-page-content":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiPageContent$1);
            }
            break;
    } });
}
defineCustomElement$1();

const WuiPageContent = WuiPageContent$1;
const defineCustomElement = defineCustomElement$1;

export { WuiPageContent, defineCustomElement };

//# sourceMappingURL=wui-page-content.js.map